import iMailbox from "../../../../assets/icons/mailbox.svg";
import iMappin from "../../../../assets/icons/mappin.svg";
import iPhone from "../../../../assets/icons/phone.svg";
import iFooterLogo from "../../../../assets/icons/footer-logo.png";
import privacyPolicyPdf from "../../../../assets/files/footer-form/policy-privacy.pdf";
import userAgreementPdf from "../../../../assets/files/footer-form/user-agreement.pdf";
import "./footer-info.sass";

const FooterInfo = () => {
  return (
    <div className="footer-info">
      <div className="footer-info__upper">
        <div className="footer-info__block">
          <div className="footer-info__name">
            <img src={iMailbox} className="footer-info__icon" alt="" />
            Почта
          </div>

          <a href="mailto:info@creon-cg.com" className="footer-info__value">
            info@creon-cg.com
          </a>
        </div>

        <div className="footer-info__block">
          <div className="footer-info__name">
            <img src={iPhone} className="footer-info__icon" alt="" />
            Телефон
          </div>

          <a href="tel:+74950322255" className="footer-info__value">
            +7 (495) 032-22-55
          </a>
        </div>

        <div className="footer-info__block">
          <div className="footer-info__name">
            <img src={iMappin} className="footer-info__icon" alt="" />
            Адрес
          </div>

          <a
            href="https://yandex.ru/maps/?text=Москва%2C%20ул.%20Большая%20Новодмитровская%2C%2036%20стр.%202"
            target="_blank"
            rel="noreferrer"
            className="footer-info__value"
          >
            Москва, ул. Большая Новодмитровская, 36 стр. 2
          </a>
        </div>
      </div>

      <div className="footer-info__logo-block">
        <img src={iFooterLogo} className="footer-info__logo" alt="" />
      </div>

      <div className="footer-info__docs">
        <div className="footer-info__block">
          <a
            href={privacyPolicyPdf}
            target="_blank"
            rel="noreferrer"
            className="footer-info__value"
          >
            политика конфиденциальности
          </a>
        </div>

        <div className="footer-info__block">
          <a
            href={userAgreementPdf}
            target="_blank"
            rel="noreferrer"
            className="footer-info__value"
          >
            пользовательское соглашение
          </a>
        </div>
      </div>
    </div>
  );
};

export default FooterInfo;
